<template>
  <div class="field">
    <div v-for="option in options" class="control">
      <label class="radio" :disabled="option.available === 0">
        <input
          type="radio"
          :name="name"
          :value="option.id"
          :checked="value.id === option.id"
          @change="$emit('input', option)"
          :disabled="option.available === 0" />
        {{ option.title }}
      </label>
      <a
        v-if="option.link"
        :href="option.link"
        target="_blank"
        class="tag is-link is-light">
        website
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "RadioGroup",
  props: ["name", "options", "value"],
};
</script>

<style scoped>
.radio {
  padding: 6px 6px 6px 0;
}
</style>
